import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withStyles, Grid } from "@material-ui/core";
import axios from 'axios';
import { currentHttpOptions } from '../common/utilities/utilitiesFunctions';
import WPSettings from '../WorkplanManager/Admin';
import { faHistory, faCalendarEdit } from '@fortawesome/pro-solid-svg-icons';
import { faBallotCheck } from '@fortawesome/pro-regular-svg-icons';
import AppDrawer from '../common/components/UI/AppDrawer/AppDrawer';

const emptyPublicConfigs = {
    appEnvironment: '',
    isMultiLanguage: true,
    version: '',
};

const styles = () => ({
    root: {
        width: '97%',
        display: 'flex',
        marginBlockStart: "1%",
        position: 'relative',
    },
    fullHeight: {
        height: '100%'
    },
    textAlignCentered: {
        textAlign: 'center'
    },
    settingContainer: {
        width: '99%',
        paddingLeft: 20
    },
    drawerPaper: {
        width: '16%',
        backgroundColor: '#0a54a2',
        minWidth: '170px'
    },
    drawer: {
        flexShrink: 0,
    },
    navElement: {
        color: 'white',
        fontWeigth: 500
    },
    listItem: {
        padding: '16px'
    },
    selected: {
        backgroundColor: '#6EA0D7 !important'
    },
    icon: {
        fontSize: '20px'
    },
    content: {
        flexGrow: 1,
    },
    logoDrawer: {
        backgroundColor: '#6EA0D7',
        textAlign: 'center',
        padding: '20px',
        margin: '20px',
        border: '1px solid #6ea0d7',
        borderRadius: '3px',
        minHeight: '1px'
    },
    logoImg: {
        width: '80%'
    },
    secondIcon: {
        position: 'absolute',
        margin: 5,
        color: 'white'
    },
    backdrop: {
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1
    },
    contentWrapper: {
        zIndex: 0,
        position: 'relative'
    }
});

const appIcon = {
    callList: ['fal', 'phone'],
    quotaManagement: ['fal', 'chart-pie'],
    requestCalendar: ['fal', 'calendar'],
    hcScheduleReport: ['fal', 'clock'],
    dailyShiftBidding: faBallotCheck,
    shiftBidding: ['fal', 'calendar-alt'],
    vacationBidding: ['fal', 'plane-departure'],
    workplanManager: faCalendarEdit,
    shiftHistory: faHistory
}

class AdminSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            applicationSelected: "common",
            applications: [{ "name": "common", "api": "dimensions", "status": "active", "env_sso": "active", "sso": true, "env": ["admin"], "managerViews": [], "token": false }],
            extended: false
        }
        document.title = "Workplan Manager (Admin)";
        this.init();
    }

    init = async () => {

        const { data: publicConfigs } = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/public/configs', currentHttpOptions());
        Object.keys(emptyPublicConfigs).forEach((key) => {
            sessionStorage.setItem(key, publicConfigs[key]);
        });
    }

    handleOnClickApplication = (name) => {
        this.setState({ applicationSelected: name });
        localStorage.setItem('appSelected', name);
    }

    handleSideMenu = (event, extend) => {
        event.stopPropagation()
        this.setState({ extended: extend })
    }

    render() {
        const { classes, refreshAdmin } = this.props;
        const { extended, applicationSelected, applications } = this.state;

        return <React.Fragment>
            <Grid item xs={12} className={classes.content}>
                <div className={classes.contentWrapper}>
                    <AppDrawer
                        applicationSelected={applicationSelected}
                        applications={applications}
                        appIcon={appIcon}
                        extended={extended}
                        handleSideMenu={this.handleSideMenu}
                        handleOnClickApplication={this.handleOnClickApplication}
                        t={this.props.t}
                    />
                    {<WPSettings refreshAdmin={refreshAdmin} />}
                </div>
                {extended ? <div className={classes.backdrop} onClick={(event) => this.handleSideMenu(event, false)}></div> : null}
            </Grid>
        </React.Fragment>
    }
}

export default translate(['common', 'hcScheduleReport', 'workplanManager', 'quotaManagement', 'requestCalendar', 'dailyShiftBidding', 'vacationBidding', 'shiftBidding', 'shiftHistory'])(withStyles(styles)(AdminSettings));